<script setup lang="ts">
import { useSelectReason } from '../../../model/additional-info/billing/info-failed-payment/select-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectReason from './info-failed-payment/SelectReason.vue'

defineOptions({
  name: 'InfoFailedPayment',
})

const { isRequired, isVisible } = useSelectReason()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      v-if="isVisible"
      title="Reason"
      :required="isRequired"
    >
      <SelectReason />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
